import _ from 'lodash'
import $ from '../shared/helper'
import { ATYPES, MTYPES } from './types'
import { CONFIG_TO_FIELDS, CONST, FORM_PROPERTIES } from '../shared/constants'
import { FIELDS } from '@/src/plugins/vue-gridform/shared/fieldtypes'

const _DEBUG = false
const _DEBUG_DETAILED = false
const _DEBUG_CHANGES = false
const _DEBUG_TIME_ONLY = false
const _W = new Map() // key = state.name, { must_not: true/false, fields: []}
const _USE_STORE = false

function getFieldListId(obj) {
    let id = obj && obj.id ? obj.id : obj.fieldlist && obj.fieldlist.id ? obj.fieldlist.id : ''
    id = id || (obj.fieldlist && obj.fieldlist.initials) || 'default'
    return id
}

// Inline Web Worker to calculate fieldlist ratings
const _IW = !!window.Worker ? new window.InlineWorker(_fls => {
    const fls = JSON.parse(_fls)
    const flsRatings = {}
    fls.forEach(fl => {
        flsRatings[getFieldListId(fl)] = ratings(fl.rows, fl.fieldlist.weighting)
    })
    return JSON.stringify(flsRatings)

    function ratings(rows, weighting) {
        let sumScore = 0
        let sumWScore = 0
        let sumMax = 0
        let sumWMax = 0
        rows.forEach(cols => {
            cols.forEach(col => {
                // recalc current rating for this field
                if (col.rating !== false) {
                    col.rating = ratingField(col)
                }
                // exclude field with no rating
                if (col.rating && !col.rating.noRating && col.rating.max) {
                    // do not add rating when fieldlist is excluded
                    const flNoRating = col.fieldlist ? !!col.fieldlist.noRating : false
                    if (!flNoRating) {
                        sumScore += col.rating.score
                        sumWScore += col.rating.wscore
                        sumMax += col.rating.max
                        sumWMax += col.rating.wmax
                    }
                }
            })
        })
        let rating = null
        if (sumMax) {
            let wscore = sumWScore
            let wmax = sumWMax
            if (weighting >= 0 && weighting < 100) {
                wscore = sumWScore * weighting / 100
                wmax = sumWMax * weighting / 100
            }
            // TODO calc with rounded sum?
            // wscore = Math.round(wscore)
            rating = buildRatingSum({ score: sumScore, wscore, max: sumMax, wmax })
        }
        return rating
    }
    // TODO use class RatingField
    function ratingField(_field) {
        const field = _field
        const fieldlist = field.fieldlist || {}
        if (fieldlist.internal) return // skip internal fieldlists
        if (fieldlist.activate && !fieldlist.activated) return // skip deactivated fieldlists

        const rating = field.rating || {}
        const noRating = !!rating.noRating // is field excluded from rating?
        const weighting = field.weighting || 100

        let value = field.value
        let score
        let min
        let max
        let maxValue

        if (field.type === 'slider') {
            value = Number(field.value)
            const tickLabels = field.customLabels || field.tickLabels
            const tl = Array.isArray(tickLabels) ? tickLabels : typeof tickLabels === 'string' ? tickLabels.split(',') : []
            min = Number(tl.length ? tl[0] : field.min)
            max = Number(tl.length ? tl.slice(-1) : field.max)
            // score = !_.isUndefined(field.value) && tl.length ? Number(tl[field.value]) : field.value || min
            // prevent invalid value
            if (value < min) field.value = min
            if (value > max) field.value = max
            // current value is current score
            score = Number(field.value)

            // set component props if not defined
            field.min = min
            field.max = max
            // field.min = field.min || min
            // field.max = field.max || tl.length - 1
            // field.tickLabels = !_.isEmpty(tl) ? tl : _.range(field.min, field.max + 1, field.step)
            // field.tickLabels = field.tickLabels.map((v) => v.toString())
            // maxValue = parseInt(_.last(field.tickLabels)) || field.tickLabels.length - 1
            maxValue = field.max
        }
        else if (field.type === 'checkbox' || field.type === 'switch') {
            min = 0
            max = 1
            score = field.value ? 1 : 0 // field is true or false
            maxValue = true
        }
        else if (field.type === 'rating') {
            min = 0
            max = 5
            score = field.value
            maxValue = max
        }
        else if (field.type === 'range') {
            min = field.min
            max = field.max
            maxValue = max - min + 1
            if (Array.isArray(field.value)) {
                // fix invalid range value
                if (field.value[0] > max) field.value[0] = min
                if (field.value[1] > max) field.value[1] = max
                score = (field.value[1] - field.value[0]) + 1
            }
            // const tickLabels = field.customLabels || field.tickLabels
            // field.tickLabels = !_.isEmpty(tickLabels) ? tickLabels : _.range(field.min, field.max + 1, field.step)
        }
        else if (field.type === 'combobox' || field.type === 'radio') {
            maxValue = 'items'
            min = !field.multiple ? field.min || 0 : 0
            max = !field.multiple ? field.max || 0 : 0

            if (Array.isArray(field.items)) {
                if (typeof min === 'string') {
                    let c_min = Number.MAX_SAFE_INTEGER
                    field.items.forEach(item => {
                        c_min = Math.min(c_min, +item.avatar)
                    })
                    min = c_min
                }
                if (typeof max === 'string') {
                    let c_max = 0
                    field.items.forEach(item => {
                        c_max = Math.min(c_max, +item.avatar)
                    })
                    max = c_max
                }
                let val
                field.items.forEach(item => {
                    item.avatar = typeof item.avatar !== 'undefined' ? `${item.avatar}` : '1'
                    val = Number(item.avatar)
                    // multiple selections => possible ratings must be added
                    if (field.multiple) val > 0 ? max += val : min += val
                    else {
                        if (typeof min === 'number') min = Math.min(min, val)
                        if (typeof max === 'number') max = Math.max(max, val)
                    }
                })
            }

            score = 0
            if (Array.isArray(field.value)) {
                if (field.type === 'radio') {
                    const fv = field.value
                    field.items.forEach(v => {
                        if (fv.includes(v.value)) score += Number(v.avatar)
                    })
                }
                else field.value.forEach(v => {score += Number(v.avatar)})
            }
            else {
                // TODO check this, when field.value === "" (ex. type=radio) score is set to 1 instead of 0
                const item = field.value && field.value.value ? field.value : field.items.find(item => item.value === field.value)
                score = item ? +item.avatar : 0
                if (!item) {
                    const c_score = field.rating.score
                    const c_item = field.items.find(item => item.avatar === `${c_score}`)
                    if (c_item) {
                        score = c_score
                        field.value = c_item.value
                        // const c_min = _.minBy(field.items, item => Number(item.avatar))
                        // const c_max = _.maxBy(field.items, item => Number(item.avatar))
                        // console.log('c_min, c_max', c_min, c_max)
                        min = field.rating.min
                        max = field.rating.max
                    }
                }
            }
        }
        else if (field.rating) {
            min = field.rating.min
            max = field.rating.max
            score = field.rating.score
            // NOTE we could not use this as value, gf.rating() checks this and update the rating object
            maxValue = 'rating'
        }
        if (typeof score === 'undefined') return

        return recalc({ min, max, maxValue, score, noRating, weighting })
    }
    function recalc(calced) {
        if (typeof calced.max === 'undefined') return

        if (calced.score < calced.min) calced.score = calced.min
        if (calced.max > calced.maxValue) calced.max = calced.maxValue

        calced.wscore = calced.score
        calced.wmax = calced.max
        if (calced.weighting >= 0 && calced.weighting < 100) {
            calced.wscore = calced.score * calced.weighting / 100
            calced.wmax = calced.max * calced.weighting / 100
        }

        calced.percent = calced.max ? calced.score * 100 / calced.max : 0
        // const percent = max - min ? score * 100 / (max - min) : 0
        calced.label = `${calced.wscore} / ${calced.wmax}`
        // calced.label = `${$.toFixed(calced.wscore)} / ${$.toFixed(calced.wmax)}`
        calced.color = percentToColor(calced.percent, 0.5)
        calced.progressColor = percentToColor(calced.percent)
        calced.hint = !isNaN(calced.percent) ? `${percentToGrade(calced.percent)} (${Math.round(calced.percent)}%)` : ''
        calced.labelPercent = !isNaN(calced.percent) ? `${Math.round(calced.percent)}%` : '0'
        return calced
    }
    function buildRatingSum({ score, wscore, max, wmax } = {}) {
        const percent = max ? score * 100 / max : 0
        const label = `${Math.round(wscore)}/${Math.round(wmax)}`
        const diff = score - wscore
        const wlabel = score !== wscore ? `${score}/${max}` : ''
        const color = percentToColor(percent, 0.5)
        const progressColor = percentToColor(percent)
        const hint = `${percentToGrade(percent)} (${Math.round(percent)}%)`
        const labelPercent = !isNaN(percent) ? `${Math.round(percent)}%` : '0'
        return { score, wscore, max, wmax, percent, label, wlabel, diff, color, progressColor, hint, labelPercent }
    }
    function percentToColor(percent, alpha = 1) {
        let color = ''
        switch (true) {
            case percent >= 95:
                color = '#518F0A'
                break
            case percent >= 90:
                color = '#7CB342'
                break
            case percent >= 85:
                color = '#A0C53F'
                break
            case percent >= 80:
                color = '#9CCC65'
                break
            case percent >= 75:
                color = '#C8E37F'
                break
            case percent >= 70:
                color = '#FFEE58'
                break
            case percent >= 65:
                color = '#FFEB3B'
                break
            case percent >= 60:
                color = '#EECA2C'
                break
            case percent >= 55:
                color = '#F3A729'
                break
            case percent >= 50:
                color = '#F17D0E'
                break
            case percent < 50:
                color = '#D24444'
                break
        }
        return color
        // if (alpha === 1) return color
        // const rgb = ColorConvert.hex.rgb(color)
        // return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`
    }
    function percentToGrade(percent) {
        let grade = ''
        switch (true) {
            case percent >= 95:
                grade = 'sehr gut (1)'
                break
            case percent >= 90:
                grade = 'sehr gut (1-)'
                break
            case percent >= 85:
                grade = 'gut (2+)'
                break
            case percent >= 80:
                grade = 'gut (2)'
                break
            case percent >= 75:
                grade = 'gut (2-)'
                break
            case percent >= 70:
                grade = 'befriedigend (3+)'
                break
            case percent >= 65:
                grade = 'befriedigend (3)'
                break
            case percent >= 60:
                grade = 'befriedigend (3-)'
                break
            case percent >= 55:
                grade = 'ausreichend (4+)'
                break
            case percent >= 50:
                grade = 'ausreichend (4)'
                break
            case percent < 50:
                grade = 'nicht ausreichend (5)'
                break
        }
        return grade
    }
}) : null

export default {
    namespaced: true, // name of gridform instance
    strict: true,

    state() {
        return {
            name: '',
            uuid: '',
            config: {},
            rows: [],
            fieldLists: [],
            fieldListsGrouped: {},
            fieldListFocused: '',
            fieldsData: {},
            fields: [], // flatten rows
            fieldsKeys: [],
            formdata: [],
            formdataKeyed: {},
            // TODO rollbacks as array in chronologic order for UNDO events?
            rollback: {},
            autofocus: null,
            validation: {},
            store: {}
        }
    },

    //
    // MUTATIONS (store.commit)
    //
    // NOTE mutations must not be async
    //  never modify an object or array directly, use Object.assign() or _.extend()
    //  https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
    //
    mutations: {
        //
        // Set state from given gridform configuration
        // payload = {name, config}
        //
        [MTYPES.ADD_FORM](state, payload) {
            if (!payload || !payload.name || !payload.config) return

            const timeLabel = `add-gridform:${payload.name}`
            if (_DEBUG) console.time(timeLabel)

            const gfdef = $.init(payload.config, payload.name)

            state.name = payload.name
            state.config = _.omit(gfdef, 'rows')

            // create flat name state
            _W.set(payload.name, {})
            $.setToggleState(gfdef.rows)
            this.commit($.ns(MTYPES.ADD_ROWS, payload.name), {rows: gfdef.rows})

            // assign global settings from configuration
            // this triggers the correct rendering of gridform
            state.global = Object.assign({}, state.global, _.pick(gfdef, _.keys(state.global)))

            if (!state.config.validate) state.validation = Object.assign({}, {valid: true})

            // when using gf state with uuids
            // we watch every change on fieldlists
            // and store the current state
            if (_USE_STORE && state.config.uuid) {
                this.watch(
                    () => state.fieldLists,
                    () => {
                        state.store[state.uuid] = {
                            rows: state.rows,
                            fieldLists: state.fieldLists,
                            fieldListsGrouped: state.fieldListsGrouped,
                            fieldsKeys: state.fieldsKeys,
                            fieldsData: state.fieldsData,
                            rollback: state.rollback,
                            fields: state.fields
                        }
                    }
                )
            }

            if (_DEBUG) console.timeEnd(timeLabel)
        },

        //
        // queue changes on the gridform
        // check for differences and prevent events for unchanged props
        // payload: {[name]: {value}}
        //
        [MTYPES.UPDATE_GRIDFORM](state, payload) {
            if (_.isEmpty(payload)) return

            const updates = _.cloneDeep(payload)
            const validNames = _.pick(updates, state.fieldsKeys)
            if (_.isEmpty(validNames)) {
                console.warn('mutation:UPDATE_GRIDFORM - invalid update name(s) detected!', updates, state.fieldsKeys)
                return
            }

            // control watched fields
            const watcher = _W.get(state.name)
            // prevent disabled fields get enabled
            const disabledFields = _.flatten(
                _.toArray(watcher)
                    .filter((w) => w.disabled)
                    .map((w) => w.fields)
            )

            // build changes
            const changes = {}
            _.each(validNames, (props, name) => {
                // remove property disabled for watched fields
                if (props && props.disabled === false && _.includes(disabledFields, name)) {
                    props = _.omit(props, 'disabled')
                }

                // check if props are equal to current state in the queue
                if (!_.isEmpty(props)) {
                    // update props in queue
                    changes[name] = Object.assign({}, changes[name], props)

                    // only check watcher if value has changed
                    // and watcher exists for this instance and field name
                    if (_.has(props, 'value') && watcher[name]) {
                        this.commit($.ns(MTYPES.CHECK_WATCHER, state.name), {
                            name,
                            value: props.value
                        })
                    }
                }
            })

            if (!_.isEmpty(changes)) {
                // check all changes with current values and prevent apply if no diffs found
                const hasDiffs = $.hasDiffs(state.fields, payload)
                if (!hasDiffs) {
                    if (_DEBUG && _DEBUG_DETAILED) console.log('%cno diffs found! name=%s', 'color:red', state.name, payload)
                }
                // apply changes with payload
                // v-gridform is subscribed to this mutation event for callback
                else {
                    this.commit($.ns(MTYPES.APPLY_CHANGES, state.name), changes)
                }
            }
        },
        // NOTE do not use directly, always mutate with UPDATE_GRIDFORM
        [MTYPES.APPLY_CHANGES](state, payload) {
            if (_.isEmpty(payload)) return // no changes

            const timeLabel = `apply-changes:${state.name}`
            if (_DEBUG) console.groupCollapsed(timeLabel)
            if (_DEBUG || _DEBUG_TIME_ONLY) console.time(timeLabel)
            if (_DEBUG_CHANGES) console.log('changes', state.name, Object.keys(payload), payload)
            else if (_DEBUG) console.log('changes "%s"', JSON.stringify(payload))

            // assign changes to gridform rows definition state
            // this triggers by example getters.rows = re-render form fields
            const rows = state.rows.map(row => {
                return row.map(field => {
                    // invalidate fieldlist rating for recalculation
                    if (payload[field.name]) {
                        const id = getFieldListId(field)
                        if (id && state.fieldListsGrouped[id]) {
                            state.fieldListsGrouped[id] = void 0
                        }
                    }
                    return $.rebuildField(field, payload)
                })
            })
            $.setToggleState(rows)
            this.commit($.ns(MTYPES.SET_ROWS, state.name), rows)

            if (state.config.store) {
                // omit fields with store=false configuration (ex. password)
                const omitFields = _.filter(state.fields, field => field.store === false).map(field => field.name)
                const storeData = _.filter(state.formdata, fd => !_.includes(omitFields, fd.name))
                if (_DEBUG) console.log('save payload', JSON.stringify(storeData, null, 4))
                $.setStore($.storeKey(state.name), storeData)
            }

            if (_DEBUG || _DEBUG_TIME_ONLY) console.timeEnd(timeLabel)
            if (_DEBUG) console.groupEnd()
        },

        // mutate state.rows
        [MTYPES.SET_ROWS](state, rows) {
            state.fields = _.flatten(rows)
            this.commit($.ns(MTYPES.SET_FIELDS, state.name)) // time: 31ms

            // if validation is active
            // - validate all fields with current form data
            // - check validation state and set first invalid field to focus
            if (state.config.validate) { // time: 0.005ms
                const errorsNamed = {}
                let errorsList = []
                let errors = 0
                let firstInvalid = null

                // validate fields and set errors
                // count sum, create list as array and named
                // set first invalid field
                _.each(state.fields, col => {
                    col.errors = $.validate(col, state.formdataKeyed)
                    if (!_.isEmpty(col.errors)) {
                        if (!firstInvalid) firstInvalid = _.pick(col, ['name', 'value'])
                        errors += _.size(col.errors)
                        const mapped = col.errors.map(error => {
                            return {
                                name: col.name,
                                label: col.label,
                                error
                            }
                        })
                        errorsList = errorsList.concat(mapped)
                        errorsNamed[col.name] = mapped
                        // only put messages in validation state when field was changed
                        // this way the state is not valid, we have the number of errors
                        // but the field will not show all the error messages on start
                        if (!col.dirty && state.config.lazyValidation) col.errors.length = 0
                    }
                })
                // sum errors for toggle fields
                _.each(state.fields, col => {
                    if (col.type === 'divider' && col.toggle) {
                        let ec = 0
                        let el = []
                        if (!_.isEmpty(errorsNamed)) {
                            _.each(col.toggle, fldName => {
                                const errors = errorsNamed[fldName]
                                if (errors) {
                                    ec += _.size(errors)
                                    el = el.concat(errors)
                                }
                            })
                        }
                        col.errors = el
                        col.errorCount = ec
                    }
                })

                state.validation = Object.assign({}, {
                    valid: errors === 0,
                    errors,
                    errorsList,
                    invalid: firstInvalid,
                    last: new Date().toISOString()
                })
            }

            state.rows = rows
            this.commit($.ns(MTYPES.SET_FIELDLISTS, state.name))
        },
        // mutate state.fieldLists
        // set tabindex for fields
        // set errorCount from fields
        [MTYPES.SET_FIELDLISTS](state) {
            // NOTE flatten is a problem
            //  => grouped rows creates a single row (different look, without gap between fields)
            const grouped = _.groupBy(state.rows, row => { // time: 0.94ms
                return getFieldListId(_.first(row))
            })

            let index = 0
            const fls = []
            _.each(grouped, (rows, id) => { // time: 0.85ms
                const fieldlist = $.getFieldlist(rows)
                let errorCount = 0
                let errors = []
                _.flatten(rows).forEach(field => {
                    // no error messages from toggle divider
                    if (!field.toggle && field.errors && field.errors.length) {
                        errorCount += field.errors.length
                        errors = errors.concat(field.errors.map(error => {
                            return {
                                name: field.name,
                                label: field.label,
                                error
                            }
                        }))
                    }
                })
                fls.push({ id, fieldlist, rows, index, errorCount, errors })
                index++
            })

            // set index of fieldlist as prop
            // enumerate all rows and set auto tabindex for keyboard navigation with TAB
            if (state.config.tabindex !== -1) {
                // let tabindex = _.isUndefined(state.config.tabindex) ? 1 : state.config.tabindex
                _.each(fls, (fl, index) => {
                    fl.index = index
                    _.flatten(fl.rows).forEach(col => {
                        // TODO check other conditions to set no tabindex
                        col.tabindex = col.disabled || col.hidden ? '-1' : '0'
                        // col.tabindex = col.disabled || col.hidden ? '-1' : `${tabindex++}`
                    })
                })
            }

            // NOTE this triggers gridform row builder
            state.fieldLists = fls
            // if no fieldlist is focused, set focused id to the first fieldlist with an id
            this.commit($.ns(MTYPES.SET_FIELDLISTS_FOCUS, state.name))

            if (state.config.rating && fls.length) { // time: 2549ms
                this.dispatch($.ns(ATYPES.GFFIELDLISTSRATING, state.name))
            }
        },
        // fieldlist ratings
        [MTYPES.SET_FIELDLISTS_GROUPED](state, payload) {
            state.fieldListsGrouped = payload
        },
        [MTYPES.SET_FIELDLISTS_RATING](state) {
            const fls = state.fieldLists
            // calc scoring for each filelist
            fls.forEach(fl => {
                const id = getFieldListId(fl)
                if (id) fl.fieldlist.rating = state.fieldListsGrouped[id]
            })
            state.fieldLists = _.cloneDeep(fls)
        },
        // set focus state to fieldlist, if activated
        [MTYPES.SET_FIELDLISTS_FOCUS](state) {
            const fls = state.fieldLists
            if (!state.config.fieldlistFocusable || !fls.length) return

            if (state.fieldListFocused) {
                let focusedFound = false
                state.fieldLists = _.map(fls, fl => {
                    if (fl.fieldlist) {
                        fl.fieldlist.focused = fl.fieldlist.id === state.fieldListFocused
                        if (fl.fieldlist.focused) focusedFound = true
                    }
                    return fl
                })
                if (!focusedFound) state.fieldListFocused = '' // focused fieldlist not found, reset state
            }
            // set focus to first fieldlist with id
            if (!state.fieldListFocused) {
                const first = _.find(fls, fl => !!_.get(fl, 'fieldlist.id'))
                if (first) {
                    first.fieldlist.focused = true
                    state.fieldListFocused = first.fieldlist.id
                }
            }
        },
        // mutate state.formdata, state.formdataKeyed
        [MTYPES.SET_FIELDS](state) {
            // assign current form data
            // [{name, value}]
            // NOTE this triggers v-gridform.unwatchFormData for validation with custom callback handler
            state.formdata = state.fields
                .filter(field => !_.isUndefined(field.value))
                .map(field => ({
                    name: field.name,
                    value: field.value
                }))

            // assign current form data (keyed)
            // {[name]: value}
            const formdataKeyed = {}
            _.each(state.formdata, field => {
                formdataKeyed[field.name] = field.value
            })
            state.formdataKeyed = Object.assign({}, formdataKeyed)
        },

        //
        // Change gridform configuration
        // - set form properties like fieldstyle, disabled, elevation, size, toolbar, drawer, menu
        // NOTE do not change field properties here
        //
        [MTYPES.CONFIG_GRIDFORM](state, payload) {
            if (_.isEmpty(payload)) return

            const config = {}
            // [{name, value}]
            if (_.isArray(payload)) {
                _.each(payload, (change) => {
                    if (!_.isUndefined(change.value)) config[change.name] = change.value
                })
            }
            // {name: {value}} or {name: value}
            else {
                _.each(payload, (change, key) => {
                    if (change && !_.isUndefined(change.value)) config[key] = change.value
                    else config[key] = change
                })
            }
            if (_.isEmpty(config)) return

            // check for valid config options
            const validOptions = _.pick(config, Object.keys(FORM_PROPERTIES))
            if (_.isEmpty(validOptions)) return

            const timeLabel = `config-gridform:${state.name}`
            if (_DEBUG) console.groupCollapsed(timeLabel)
            if (_DEBUG) console.time(timeLabel)
            if (_DEBUG) console.log('changes "%s"', JSON.stringify(validOptions))

            // assign changes to config state
            state.config = Object.assign({}, state.config, validOptions)

            if (_DEBUG) console.timeEnd(timeLabel)
            if (_DEBUG) console.groupEnd()

            // check changes to fields state
            // some config settings will be copied to fields
            // ex. fieldstyle, disabled
            const fieldOptions = _.pick(validOptions, CONFIG_TO_FIELDS)
            if (!_.isEmpty(fieldOptions)) {
                const changes = $.buildPayload(state.fields, fieldOptions)
                // prevent empty mutation
                if (changes) this.commit($.ns(MTYPES.UPDATE_GRIDFORM, state.name), changes)
            }
        },

        [MTYPES.RELOAD_GRIDFORM](state, payload) {
            const config = _.cloneDeep(payload)
            if (_DEBUG) console.log('RELOAD GRIDFORM payload', state.name, config)
        },

        //
        // Watcher to handle field dependencies
        // disabled/enabled state of fields can depend on other field states
        //
        [MTYPES.CHECK_WATCHER](state, payload = {}) {
            const {name, value} = payload
            if (!name) return

            const watch = _W.get(state.name)[name]
            if (!watch) return

            const disable = {}
            const disabled = (watch.disabled = watch.must_not ? !!value : !value)
            _.each(watch.fields, (field) => {
                disable[field] = {disabled}
            })

            if (!_.isEmpty(disable))
                this.commit($.ns(MTYPES.UPDATE_GRIDFORM, state.name), disable)
        },

        //
        // Add new row or column
        //
        [MTYPES.CLEAR_ROWS](state) {
            if (_DEBUG_DETAILED) console.log('clear rows')
            this.commit($.ns(MTYPES.SET_ROWS, state.name), [])
            state.fieldListsGrouped = {}
            state.fieldsKeys = []
            state.formdataKeyed = []
            state.fieldsData = {}
            state.formdata = []
            state.rollback = {}
            state.autofocus = null
        },
        [MTYPES.ADD_ROWS](state, payload) {
            if (_.isEmpty(payload) || !$.validateRows(payload.rows)) return
            if (_.isEmpty(payload.rows)) return // empty rows are valid, but not for this mutation

            state.uuid = payload.uuid
            // use fieldlist rating from store, if exists, to minimize recalcution time
            const store = state.store[payload.uuid]
            if (_.isEmpty(state.fieldListsGrouped) && store) {
                state.rows = store.rows
                state.fieldLists = store.fieldLists
                state.fieldListsGrouped = store.fieldListsGrouped
                state.fieldsKeys = store.fieldsKeys
                state.fieldsData = store.fieldsData
                state.rollback = store.rollback
                state.fields = store.fields
                return
            }

            const rows = _.cloneDeep(payload.rows) // prevent changing payload
            const fieldlist = payload.fieldlist ? _.cloneDeep(payload.fieldlist) : void 0
            if (_DEBUG) console.log('ADD_ROWS: rows', rows)
            if (_DEBUG && fieldlist) console.log('ADD_ROWS: fieldlist', fieldlist)

            $.initRows(rows, fieldlist) // time: 0.43ms

            // first initialize the new rows
            _.each(_.flatten(rows), (ocol) => { // time: 1824ms
                const def = {...ocol}

                // initialize original col definition
                $.initField(ocol)

                // set properties from form config
                if (!state.config.lazyValidation) ocol.dirty = true
                if (state.config.disabled) ocol.disabled = true
                if (state.config.dense) ocol.dense = true
                ocol.fieldstyle = ocol.fieldstyle || state.config.fieldstyle

                if (state.config.rating && ocol.rating !== false) ocol.rating = $.rating(ocol)

                // clone original col
                const col = {...ocol}
                const { name, rollback, dirty } = col
                if (name) {
                    col.gfname = state.name

                    // field states
                    if (state.fieldsKeys.includes(name)) {
                        console.warn('VGridform: duplicated field name detected!', name, col)
                    }
                    state.fieldsKeys.push(name)

                    // data states
                    const gftype = _.get(FIELDS, `${def.type || 'text'}.label`, '???')
                    if (_DEBUG && gftype === '???') console.log('def', def)
                    state.fieldsData[name] = { def, gftype }
                    if ($.isInputField(col)) state.rollback[name] = { value: rollback, dirty }

                    // watcher
                    let watch = col.watch
                    if (watch) {
                        const cw = _W.get(col.gfname)
                        let mustnot = false
                        if (/^!/.test(watch)) {
                            mustnot = true
                            watch = watch.substr(1)
                        }
                        cw[watch] = cw[watch] || {fields: []}
                        cw[watch].must_not = mustnot
                        cw[watch].fields.push(col.name)
                        _W.set(col.gfname, cw)
                    }

                    if (col.autofocus) state.autofocus = col.name
                }
            })

            // append new rows at end
            this.commit($.ns(MTYPES.SET_ROWS, state.name), _.concat(state.rows, rows)) // time: 2692ms

            const mutation = $.ns(MTYPES.CHECK_WATCHER, state.name)
            const watcher = _W.get(state.name)
            _.each(watcher, (watch, name) => {
                const value = state.formdataKeyed[name]
                this.commit(mutation, { name, value })
            })

            if (_USE_STORE && payload.uuid) {
                state.store[payload.uuid] = state.store[payload.uuid] || {}
                state.store[payload.uuid] = {
                    rows: state.rows,
                    fieldLists: state.fieldLists,
                    fieldListsGrouped: state.fieldListsGrouped,
                    fieldsKeys: state.fieldsKeys,
                    fieldsData: state.fieldsData,
                    rollback: state.rollback,
                    fields: state.fields
                }
            }
        },

        // move a row up or down
        [MTYPES.MOVE_ROW](state, payload) {
            if (!payload) return

            const name = payload.name
            const direction = (payload.direction || 'down').trim().toLowerCase()
            if (!name || !_.includes(['up', 'down', 'first', 'last'], direction)) return

            const from = _.findIndex(state.rows, (row) => {
                return !_.isUndefined(_.find(row, {name}))
            })

            let to
            if (direction === 'up' && from > 0) to = from - 1
            else if (direction === 'down' && from < state.rows.length - 1) to = from + 1
            else if (direction === 'first' && from > 0) to = 0
            else if (direction === 'last' && from < state.rows.length - 1) to = state.rows.length - 1

            if (!_.isUndefined(to)) {
                const rows = _.cloneDeep(state.rows)
                rows.splice(to, 0, rows.splice(from, 1)[0])
                this.commit($.ns(MTYPES.SET_ROWS, state.name), rows)
            }
        },

        // update extra field data
        [MTYPES.UPDATE_FIELD_DATA](state, payload) {
            if (_.isEmpty(payload)) return

            const fieldsData = _.cloneDeep(state.fieldsData)
            _.each(payload, (update, fieldName) => {
                const fd = state.fieldsData[fieldName]
                if (fd) {
                    fieldsData[fieldName] = Object.assign({}, fd, update)
                }
            })
            state.fieldsData = fieldsData
        },

        // update fieldlist data
        // payload.remove=true => unset fieldlist for given id
        [MTYPES.UPDATE_FIELDLIST](state, payload) {
            if (_.isEmpty(payload)) return

            const id = payload.id || state.fieldListFocused // given fieldlist id or focused

            let rows
            // add a row to a fieldlist
            if (payload.add) {
                const fls = state.fieldLists.find(fl => fl.fieldlist.id === payload.id)
                if (!fls) return

                fls.rows.push(payload.rows)
                rows = []
                _.each(state.fieldLists, fl => {
                    rows = rows.concat(fl.rows)
                })
            }
            else if (payload.focused) {
                state.fieldListFocused = payload.focused
                this.commit($.ns(MTYPES.SET_FIELDLISTS_FOCUS, state.name))
                return
            }
            // toggle collapsed state in fieldlist (payload.id)
            else if (payload.toggle) {
                rows = state.rows.map(row => {
                    return row.map(field => {
                        return field.fieldlist && field.fieldlist.id === id
                            ? Object.assign({}, field, {
                                fieldlist: {
                                    ...field.fieldlist,
                                    // toggle current state or set state from payload
                                    collapsed: _.isUndefined(payload.collapsed) ? !field.fieldlist.collapsed : payload.collapsed
                                }
                            })
                            : field
                    })
                })
            }
            else if (payload.activate) {
                rows = state.rows.map(row => {
                    return row.map(field => {
                        return field.fieldlist && field.fieldlist.id === id
                            ? Object.assign({}, field, {
                                fieldlist: {
                                    ...field.fieldlist,
                                    // toggle current state or set state from payload
                                    activated: _.isUndefined(payload.activated) ? !field.fieldlist.activated : payload.activated
                                }
                            })
                            : field
                    })
                })
            }
            // remove fieldlist data
            else if (payload.remove) {
                rows = state.rows.map(row => {
                    return row.map(field => {
                        return field.fieldlist && field.fieldlist.id === id
                            ? Object.assign({}, field, {fieldlist: {}})
                            : field
                    })
                })
            }
            else if (typeof payload.isMax !== 'undefined') {
                rows = state.rows
                state.fieldListsGrouped[payload.id] = void 0
                // set isMax to fieldlist
                // TODO must we set this to all fields in the fieldlist?
                const fieldlist = state.fieldLists.find(fl => fl.id === payload.id)
                if (fieldlist) fieldlist.fieldlist.isMax = payload.isMax
            }
            else {
                const fieldlist = {...payload}
                rows = state.rows.map(row => {
                    return row.map(field => {
                        return field.fieldlist && field.fieldlist.id === id
                            ? Object.assign({}, field, {fieldlist: {...field.fieldlist, ...fieldlist}})
                            : field
                    })
                })
            }

            if (_DEBUG_DETAILED) console.log('update fieldlist', payload)
            this.commit($.ns(MTYPES.SET_ROWS, state.name), rows)
        },
        [MTYPES.UPDATE_FIELDLISTS](state, payload) {
            if (_.isEmpty(payload)) return

            const flChanges = {}
            _.each(payload, fl => {
                flChanges[fl.id] = _.omit(fl, ['id'])
            })
            const rows = state.rows.map(row => {
                return row.map(field => {
                    return field.fieldlist && flChanges[field.fieldlist.id]
                        ? Object.assign({}, field, {fieldlist: {...field.fieldlist, ...flChanges[field.fieldlist.id]}})
                        : field
                })
            })
            this.commit($.ns(MTYPES.SET_ROWS, state.name), rows)
        },

        // remove a single field from the gridform
        [MTYPES.REMOVE_FIELD](state, payload) {
            if (!payload || !payload.name) return

            const name = payload.name

            const rows = state.rows
                .map((row) => {
                    return row.filter((col) => col.name !== name)
                })
                .filter((row) => !_.isEmpty(row))

            if (_DEBUG_DETAILED) console.log('remove field', name)
            this.commit($.ns(MTYPES.SET_ROWS, state.name), rows)
            state.fieldsKeys = state.fieldsKeys.filter((fk) => fk !== name)
            delete state.rollback[name]
            delete state.fieldsData[name]
            // TODO clean up watcher
        }
    },

    //
    // ACTIONS (store.dispatch)
    //
    // NOTE actions are always async
    //
    actions: {
        [ATYPES.GFADD]({commit}, payload) {
            commit(MTYPES.ADD_FORM, payload)
        },

        // commit and save data immeditially
        [ATYPES.GFCHANGE]({commit}, payload) {
            if (_.isEmpty(payload)) return // do not mutate if not needed to prevent firing mutation event
            commit(MTYPES.UPDATE_GRIDFORM, payload)
        },

        // commit and save data debounced
        // used for changes like @input who triggers every keystroke
        [ATYPES.GFUPDATE]: _.debounce(({commit, getters}, payload) => {
            commit(MTYPES.UPDATE_GRIDFORM, payload)
        }, CONST.DEBOUNCE_UPDATE),

        [ATYPES.GFDATA]({commit}, payload) {
            commit(MTYPES.UPDATE_FIELD_DATA, payload)
        },
        [ATYPES.GFFIELDLIST]({ commit }, payload) {
            commit(MTYPES.UPDATE_FIELDLIST, payload)
        },
        // for bulk operations on fieldlists
        [ATYPES.GFFIELDLISTS]({commit}, payload) {
            if (!Array.isArray(payload)) {
                console.warn('ATYPES.GFFIELDLISTS: payload must be an array!')
                return
            }
            commit(MTYPES.UPDATE_FIELDLISTS, payload)
        },
        // Fieldlist rating calculation with "Inline Web Worker"
        [ATYPES.GFFIELDLISTSRATING]({commit, state}) {
            if (!_IW) { // no inline worker available, calculate rating synchron
                commit(MTYPES.SET_FIELDLISTS_RATING)
                return
            }

            _IW.inject(getFieldListId)
            _IW.then(result => {
                const flsRatings = $.parseJSON(result)
                commit(MTYPES.SET_FIELDLISTS_GROUPED, flsRatings)
                commit(MTYPES.SET_FIELDLISTS_RATING)
            }).run(JSON.stringify(state.fieldLists))
        },

        [ATYPES.GFRESET]({dispatch, state}) {
            dispatch(ATYPES.GFCHANGE, state.rollback)
        },

        // Modify gridform configuration
        [ATYPES.GFCONFIG]({commit}, payload) {
            if (_.isEmpty(payload)) return
            commit(MTYPES.CONFIG_GRIDFORM, payload)
        },

        [ATYPES.GFRELOAD]({commit}, payload) {
            commit(MTYPES.RELOAD_GRIDFORM, payload)
        },

        [ATYPES.GFSETROWS]({commit}, payload) {
            commit(MTYPES.CLEAR_ROWS)
            payload.rows = payload.rows.filter(row => !_.isEmpty(row)) // remove empty rows
            commit(MTYPES.ADD_ROWS, payload)
        },
        [ATYPES.GFADDROWS]({commit}, payload) {
            if (_.isEmpty(payload) || _.isEmpty(payload.rows)) return

            commit(MTYPES.ADD_ROWS, payload)
        },
        [ATYPES.GFMOVEROW]({commit}, payload) {
            commit(MTYPES.MOVE_ROW, payload)
        },

        [ATYPES.REMOVE_FIELD]({commit}, payload) {
            commit(MTYPES.REMOVE_FIELD, payload)
        },
        [ATYPES.ROLLBACK]({commit, state}, payload) {
            console.log('payload', payload)
            console.log('state.rollback[payload.name]', state.rollback[payload.name])
        },

        // example how to combine fields
        // after selection of zipcode, we set fitting city and county
        [ATYPES.GFFINDREF]({commit, state, getters, rootGetters, rootState}, payload) {
            let {zipcode, city, county} = payload

            // zipcode exists => search entry
            if (_.isString(zipcode)) {
                zipcode = _.find(
                    rootGetters['vgf/zipcode'],
                    (zp) => zp.text === zipcode
                )
                if (zipcode) {
                    // NOTE do not use update to avoid loops (subscriber should only listen to UPDATE_GRIDFORM)
                    commit(MTYPES.APPLY_CHANGES, {zipcode: {value: zipcode}})
                    city = city || zipcode.cityIndex
                    county = county || zipcode.countyIndex
                }
            }
            // full zipcode data
            else if (_.has(zipcode, 'text')) {
                city = city || zipcode.cityIndex
                county = county || zipcode.countyIndex
            }

            if (!_.isUndefined(city)) {
                const cityIndex = parseInt(city) - 1 // city data starts with index 1
                const newCity = _.get(rootState, `vgf.acData.city.${cityIndex}`)
                if (newCity) {
                    // NOTE value must be equal to items structure
                    const value = {
                        value: newCity[0],
                        text: newCity[3],
                        lng: newCity[4],
                        lat: newCity[5]
                    }
                    commit(MTYPES.UPDATE_GRIDFORM, {city: {value}})
                }
            }

            if (!_.isUndefined(county)) {
                if (county === false)
                    commit(MTYPES.UPDATE_GRIDFORM, {county: {disabled: true}})
                else {
                    const countyIndex = parseInt(county) - 1 // city data starts with index 1
                    const newCounty = _.get(rootState, `vgf.acData.county.${countyIndex}`)
                    // NOTE value must be equal to items structure
                    const value = {value: newCounty[0], text: newCounty[2]}
                    commit(MTYPES.UPDATE_GRIDFORM, {county: {value, disabled: false}})
                }
            }
        }
    },

    //
    // GETTERS (store.getters)
    //
    getters: {
        rows(state) {
            return state.rows
        },
        fieldLists(state) {
            return state.fieldLists
        },
        fieldListsGrouped(state) {
            return state.fieldListsGrouped
        },
        fieldlistFocused(state) {
            return state.fieldListFocused
        },
        fields(state) {
            return state.fields
        },
        fieldsData(state) {
            return state.fieldsData
        },
        fieldData(state) {
            return (name) => state.fieldsData[name]
        },
        fieldsKeys(state) {
            return state.fieldsKeys
        },
        config(state) {
            return state.config
        },
        // store(state) {
        //   return state.config.store
        // },
        formdata(state) {
            return state.formdata
        },
        validation(state) {
            return state.validation
        },
        // get only successful form data
        submit(state) {
            return state.fields.filter($.isSuccessfulField).map((field) => ({
                name: field.name,
                value: field.value
            }))
        },
        autofocus(state) {
            return state.autofocus
        },
        rollback(state) {
            return state.rollback
        }
    }
}
